// Web Audio success sounds — no asset files needed.
let ctx = null;
function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone(ac, freq, start, dur, type = "sine", gain = 0.18) {
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, ac.currentTime + start);
  g.gain.exponentialRampToValueAtTime(gain, ac.currentTime + start + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + start + dur);
  osc.connect(g);
  g.connect(ac.destination);
  osc.start(ac.currentTime + start);
  osc.stop(ac.currentTime + start + dur + 0.05);
}

// Pleasant ascending arpeggio for correct answers.
export function playCorrect() {
  const ac = getCtx();
  if (!ac) return;
  // C5, E5, G5, C6
  const notes = [523.25, 659.25, 783.99, 1046.5];
  notes.forEach((f, i) => tone(ac, f, i * 0.09, 0.28, "triangle", 0.16));
}

// Bright sparkle when a badge unlocks.
export function playBadge() {
  const ac = getCtx();
  if (!ac) return;
  const notes = [659.25, 987.77, 1318.51];
  notes.forEach((f, i) => tone(ac, f, i * 0.11, 0.45, "sine", 0.14));
}

// Soft, non-punishing tone for incorrect answers.
export function playWrong() {
  const ac = getCtx();
  if (!ac) return;
  tone(ac, 392, 0, 0.22, "sine", 0.1);
  tone(ac, 329.63, 0.12, 0.28, "sine", 0.1);
}
